import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "add-review-form" }
const _hoisted_2 = { class: "add-review-form__caption" }
const _hoisted_3 = { class: "add-review-form__row add-review-form__input-row" }
const _hoisted_4 = {
  key: 0,
  class: "add-review-form__error"
}
const _hoisted_5 = { class: "add-review-form__row" }

import { ref } from 'vue';

import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { getReviewContext } from '@/composables/useTycka';
import { getReviewContext as getAddReviewContext } from '@/composables/useReview';

import TextInput from '@/components/forms/TextInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddReviewForm',
  setup(__props) {

const { mitt } = useContext();
const { websiteText } = useWebsiteTexts();
const { addReview } = getReviewContext();
const { selectedVariant } = getAddReviewContext();

const review = ref('');
const reviewError = ref('');

const transactionError = ref('');

function onReviewFocused() {
  reviewError.value = '';
}

function onReviewChanged() {
  if (!review.value) {
    reviewError.value =
      websiteText('global__forms__requiredfielderror').value ||
      'global__forms__requiredfielderror';
  }
}

async function onAddReviewFormClick() {
  transactionError.value = '';

  onReviewChanged();

  if (!review.value) {
    return;
  }

  try {
    await addReview({
      variantId: selectedVariant.value.id,
      review: review.value,
    });

    let reviewedItems =
      sessionStorage.getItem('Tycka:AddReview:ItemsReviewed') || '';
    reviewedItems += `|${selectedVariant.value.id};`;
    sessionStorage.setItem('Tycka:AddReview:ItemsReviewed', reviewedItems);

    mitt.emit('Tycka:AddReview:ReviewSubmitted');
  } catch (err: any) {
    transactionError.value = err;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(websiteText)('reviews__my_opinion_caption').value ||
        'reviews__my_opinion_caption'), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(TextInput, {
        class: "add-review-form__input",
        type: "textarea",
        autofocus: true,
        autoselect: true,
        "error-message": reviewError.value,
        showErrorMessage: true,
        modelValue: review.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((review).value = $event)),
        onFocus: onReviewFocused,
        onBlur: onReviewChanged,
        ref: "reviewFormInput"
      }, null, 8, ["error-message", "modelValue"])
    ]),
    (transactionError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(transactionError.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "primary-button add-review-form__submit",
        onClick: onAddReviewFormClick
      }, _toDisplayString(_unref(websiteText)('reviews__submit_review').value ||
          'reviews__submit_review'), 1)
    ])
  ]))
}
}

})